import React, { useContext } from "react";
import { Radio } from "antd";
import MapPropsContext from "../MapPropsContext";
import { MAP_VENDOR, TI_NORMAL_MAP_BUTTON, TI_SATELITE_MAP_BUTTON } from "../../../Constants";
import { StyledButton } from "../../../styled-components/Button";

const WidgetMapType = ({ style, isDisabled }) => {
  const { mapType, setMapType } = useContext(MapPropsContext);

  /*
  const [isSatellite, setIsSatellite] = useState(false);
  function isKeyPressed(e) {
    if (e.ctrlKey)
      setIsSatellite(true);
  }
  */

  return (
    <>
      <StyledButton
        // style={{ borderTopLeftRadius: "4px", borderBottomLeftRadius: "4px" }}
        value={`leaflet-${MAP_VENDOR}-base`}
        onClick={(e) => setMapType(e.target.value)}
        isActive={mapType === `leaflet-${MAP_VENDOR}-base`}
        tabIndex={TI_NORMAL_MAP_BUTTON}
        borderRadius="4px 0px 0px 4px"
      >
        일반지도
      </StyledButton>
      <StyledButton
        borderRadius="0px 4px 4px 0px"
        value={`leaflet-${MAP_VENDOR}-satellite`}
        disabled={isDisabled}
        onClick={(e) => setMapType(e.target.value)}
        isActive={mapType === `leaflet-${MAP_VENDOR}-satellite`}
        tabIndex={TI_SATELITE_MAP_BUTTON}
      >
        위성지도
      </StyledButton>
    </>
    // <div style={{ ...DEFAULT_STYLE, ...style }}>
    //   <Radio.Group
    //     buttonStyle="solid"
    //     defaultValue={mapType}
    //     // onChange={({ target: { value }}) => setMapType(value)} >
    //     onChange={({ target: { value } }) => {
    //       if (value === `leaflet-${MAP_VENDOR}-base`) {
    //         return setMapType(value);
    //       } else if (value === `leaflet-${MAP_VENDOR}-satellite`) {
    //         return setMapType(value);
    //       } else {
    //         return false;
    //       }
    //     }}
    //   >
    //     {/*{ MAP_VENDOR === "vworld" &&*/}
    //     <>
    //       <Radio.Button value={`leaflet-${MAP_VENDOR}-base`}>
    //         일반지도
    //       </Radio.Button>
    //       <Radio.Button
    //         value={`leaflet-${MAP_VENDOR}-satellite`}
    //         disabled={isDisabled}
    //       >
    //         위성지도
    //       </Radio.Button>
    //     </>
    //     {/*}*/}
    //   </Radio.Group>
    // </div>
  );
};

const DEFAULT_STYLE = {};

export default WidgetMapType;
